// extracted by mini-css-extract-plugin
module.exports = {"icon":"WellsFargoLogo__icon___12t2o","tpb":"WellsFargoLogo__tpb___2FEkt"};